import * as React from "react";
const SvgFiRrAssign = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-assign_svg__a)">
      <path
        fill="#062147"
        d="M10 2a2 2 0 1 1 3.999-.001 2 2 0 0 1-4 .001m-.648 6.98a1.006 1.006 0 0 0 1.18-.781A1.5 1.5 0 0 1 12 7c.71 0 1.328.504 1.469 1.199a1 1 0 0 0 1.179.781 1 1 0 0 0 .78-1.18A3.51 3.51 0 0 0 12 4.999 3.51 3.51 0 0 0 8.57 7.8c-.108.542.24 1.069.782 1.18M20.5 6a2 2 0 1 0 0-3.999A2 2 0 0 0 20.5 6M4.969 10.199a1 1 0 0 0 1.179.781 1 1 0 0 0 .78-1.18 3.51 3.51 0 0 0-3.43-2.801A3.51 3.51 0 0 0 .07 9.801c-.11.542.24 1.069.78 1.18a1.004 1.004 0 0 0 1.18-.781A1.5 1.5 0 0 1 3.5 9.001c.71 0 1.328.503 1.469 1.198M3.499 6a2 2 0 1 0 .002-3.999A2 2 0 0 0 3.5 6m20.43 3.801A3.51 3.51 0 0 0 20.5 7a3.51 3.51 0 0 0-3.43 2.801c-.108.542.24 1.069.782 1.18a1.004 1.004 0 0 0 1.18-.781A1.5 1.5 0 0 1 20.5 9.001c.71 0 1.328.504 1.469 1.199a1.002 1.002 0 0 0 1.96-.399m-4.166 8.751-4.756-1.783v-4.661c0-1.516-1.076-2.835-2.503-3.067a3.01 3.01 0 0 0-2.44.674 3 3 0 0 0-1.057 2.286v7.563l-1.015-.808c-.007-.006-.017-.007-.024-.012a2.995 2.995 0 0 0-4.022 4.438l.558.538c.186.18.435.28.694.28.9 0 1.342-1.095.694-1.72l-.568-.548a1.001 1.001 0 0 1 1.364-1.464c.01.009.023.011.033.02l1.739 1.394c.476.379 1.112.45 1.66.187.548-.265.889-.807.889-1.415V12a1.002 1.002 0 0 1 1.175-.986c.463.075.825.555.825 1.093v5.354c0 .417.259.79.648.937l5.405 2.026a3 3 0 0 1 1.94 2.634 1 1 0 0 0 .998.941q.03 0 .06-.002a1 1 0 0 0 .939-1.057 5 5 0 0 0-3.235-4.39z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-assign_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrAssign;
